module.exports = __webpack_public_path__ + "static/media/mode-511.3c09486f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-511.svg
// module id = 1041
// module chunks = 2